import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import {
  CoachingDetailsInput,
  StatusOptionsObject,
} from '../../api/CoachingForm/schema';
import CoachingDetails from './CoachingDetails/Context';
import CoachingSession from './CoachingSession/Context';
import ContactReview from './ContactReview/Context';

const validationSchema = (intl: IntlShape): Yup.ObjectSchema => {
  return Yup.object().shape({
    contactReview: Yup.array()
      .of(ContactReview(intl))
      .max(
        5,
        intl.formatMessage(
          {
            id: 'cs_perfportal_contact_review_validate_max',
            defaultMessage: 'No more than {0} contact reviews are allowed',
          },
          { 0: 5 }
        )
      ),
    coachingDetails: Yup.array()
      .of(CoachingDetails(intl))
      .required(
        intl.formatMessage({
          id: 'cs_perfportal_coaching_detail_blurb_at_least_one_required',
          defaultMessage: 'Choose at least one topic with an assigned action.',
        })
      )
      .compact(
        (value: CoachingDetailsInput | undefined | {}) =>
          !!value &&
          'status' in value &&
          ![StatusOptionsObject.PENDING, StatusOptionsObject.OPEN].includes(
            value.status
          )
      )
      .max(
        5,
        intl.formatMessage(
          {
            id: 'cs_perfportal_coaching_detail_validate_max',
            defaultMessage: 'No more than {0} open topics are allowed',
          },
          { 0: 5 }
        )
      ),

    coachingSession: CoachingSession(intl),
  });
};

export default validationSchema;
